import AppStoreIcon from './appstore.svg';
import GooglePlayIcon from './googleplay.svg';

export { AppStoreIcon, GooglePlayIcon };
